export default "__VITE_ASSET__DvTYsBcI__"